'use strict';

var _asyncToGenerator = require("C:\\Users\\chris\\Documents\\Code\\PerspectiveDeveloper\\CattlepassDapp\\client\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/asyncToGenerator");

var _regeneratorRuntime = require("C:\\Users\\chris\\Documents\\Code\\PerspectiveDeveloper\\CattlepassDapp\\client\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/regenerator");

var _awaitAsyncGenerator = require("C:\\Users\\chris\\Documents\\Code\\PerspectiveDeveloper\\CattlepassDapp\\client\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/awaitAsyncGenerator");

var _wrapAsyncGenerator = require("C:\\Users\\chris\\Documents\\Code\\PerspectiveDeveloper\\CattlepassDapp\\client\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/wrapAsyncGenerator");

var CID = require('cids');

var multihashing = require('multihashing-async');

var multihash = multihashing.multihash;

var multicodec = require('multicodec');
/**
 * @typedef {import('cids').CIDVersion} CIDVersion
 * @typedef {import('multihashing-async').multihash.HashCode} HashCode
 * @typedef {import('interface-ipld-format').Format<Uint8Array>} RawFormat
 */

/**
 * Binary resolver
 *
 * @type {RawFormat}
 */


module.exports = {
  codec: multicodec.RAW,
  defaultHashAlg: multihash.names['sha2-256'],
  resolver: {
    /**
     * Resolves a path within a Raw block.
     *
     * Always returns the raw data as value without any remainderPath.
     *
     * @param {Uint8Array} binaryBlob - Binary representation of a PB block
     * @param {string} [path='/'] - Path that should be resolved.  Must be '/' or an exception is thrown
     */
    resolve: function resolve(binaryBlob, path) {
      if (path !== '/') {
        throw new Error('Only the root path / may be resolved');
      }

      return {
        value: binaryBlob,
        remainderPath: ''
      };
    },

    /**
     * Return all available paths of a block.
     *
     * @generator
     * @param {Uint8Array} binaryBlob - The raw data
     */
    tree: function tree(binaryBlob) {
      return _wrapAsyncGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    }
  },
  util: {
    /**
     * @param {Uint8Array} data
     */
    deserialize: function deserialize(data) {
      return data;
    },

    /**
     * @param {Uint8Array} data
     */
    serialize: function serialize(data) {
      return data;
    },

    /**
     * Calculate the CID of the binary blob.
     *
     * @param {Uint8Array} binaryBlob - Encoded IPLD Node
     * @param {Object} [userOptions] - Options to create the CID
     * @param {CIDVersion} [userOptions.cidVersion=1] - CID version number
     * @param {HashCode} [userOptions.hashAlg=multihash.names['sha2-256']] - Defaults to the defaultHashAlg of the format
     */
    cid: function () {
      var _cid = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(binaryBlob) {
        var userOptions,
            options,
            hashName,
            hash,
            codecName,
            cid,
            _args2 = arguments;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                userOptions = _args2.length > 1 && _args2[1] !== undefined ? _args2[1] : {};
                options = {
                  cidVersion: userOptions.cidVersion == null ? 1 : userOptions.cidVersion,
                  hashAlg: userOptions.hashAlg == null ? module.exports.defaultHashAlg : userOptions.hashAlg
                };
                hashName = multihash.codes[options.hashAlg];
                _context2.next = 5;
                return multihashing(binaryBlob, hashName);

              case 5:
                hash = _context2.sent;
                codecName = multicodec.getNameFromCode(module.exports.codec);
                cid = new CID(options.cidVersion, codecName, hash);
                return _context2.abrupt("return", cid);

              case 9:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));

      function cid(_x) {
        return _cid.apply(this, arguments);
      }

      return cid;
    }()
  }
};